import { render, staticRenderFns } from "./error-table.vue?vue&type=template&id=36e25062"
import script from "./error-table.vue?vue&type=script&lang=js"
export * from "./error-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports